import PageLayout from './pageLayout';

const LAYOUT_MAP: Record<string, (props: any) => JSX.Element> = {
  '/secure/glasses/lenses': (props: any) => props.children,
  '/secure/checkout': (props: any) => props.children,
  '/secure/ewallet': (props: any) => props.children,
  '/secure/account/viewinvoice': (props: any) => props.children,
  '/secure/account/printrx': (props: any) => props.children,
};
/**
 * HOC to set layout based on slug.
 * @param props
 * @returns JSX.Element
 */
export default function getLayout(props: any): JSX.Element {
  const pathVars = location.pathname.split('/');
  const slug = '/' + pathVars.slice(2).join('/');
  const Layout = LAYOUT_MAP[slug];
  if (!Layout) return <PageLayout {...props} />;
  else return <Layout {...props} />;
}
